import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-account-decision-result',
  templateUrl: './modal-account-decision-result.component.html',
  styleUrls: ['./modal-account-decision-result.component.scss']
})

export class ModalAccountDecisionResultComponent {
  @Input() accountNumber: string = '';
  @Input() processedBy: string = '';
  @Input() processedDecision: string = '';
  @Input() processedReason: string = '';
  @Input() processedDate: string = '';
  @Output() successAction = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {}

  get displayDecisionText(): string {
    const decision = this.processedDecision.toUpperCase() === 'R' ? 'rejected' : 'approved';
    return `Account number ${this.accountNumber} has been ${decision} by ${this.processedBy}.`;
  }

  successActionFunc() {
    this.activeModal.close();
  }

}
